/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
export { Color, ColorMap, ColorTable } from './color';
export { ColorScale } from './scale';
//# sourceMappingURL=index.js.map